import CryptoJS from "crypto-js";

const SECRET = "SECRET";
// const SECRET = process.env.REACT_APP_SECRET || "SECRET";

const SALT = CryptoJS.enc.Utf8.parse("fixed‑salt‑123456");
const IV = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

const KEY = CryptoJS.PBKDF2(SECRET, SALT, {
  keySize: 256 / 32,
  iterations: 1_000,
});

export function createHash<T>(payload: T): string {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

export function removeHash<T>(cipherText: string): T | null {
  try {
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText),
    });

    const bytes = CryptoJS.AES.decrypt(cipherParams, KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) as T;
  } catch {
    return null; // tampered text or wrong secret
  }
}
